import React, { Component } from "react";
import AuthLayout from "./../authLayout.js"
import SimpleReactValidator from 'simple-react-validator';
import service from '../../services'
import queryString from "query-string";
import Loader from "../../component/loader.js";
import ShowPasswordIcon from './../../icons/ShowPassIcon';
import ViewIcon from "../../icons/viewIcon.js";
import { Link } from "react-router-dom";

let sub;
class Reset extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            confirmPassword: "",
            userId:"",
            loaderFlag: false,
            passShow:false,
            confirmPassShow:false,
            referralCode:''
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount = () => {
        let paramsData = this.props.location.search;
        if(paramsData){
            paramsData = paramsData.split('=')
            
            if(paramsData && paramsData[1]){
                this.setState({referralCode:paramsData[1]})
            }
        }
       
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "privateScreeningPartner|cms|resetPassword":
                    if(response.error){
                        this.setState({ loaderFlag: false })
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }else{
                        this.setState({ loaderFlag: false })
                        this.apiserve.success(response.data.message ? response.data.message : response.message)
                        this.props.history.push('/ps-signin')
                    }       
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
      }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        },()=>{
            this.validate()
        });
    }

    resetPassword = () => {
        this.apiserve.sendevent("privateScreeningPartner|cms|resetPassword", { 
            verification:this.state.referralCode,
            password:this.state.password
        }); 
    }

    validate = () => {
        let emailErr = ''
        let passwordErr = '';
        let passwordMustSameError = ''
        if (!this.state.password) {
            passwordErr = 'Password can not be blank'
        }
        else {
            if (!this.state.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d[\]{};:=<>_+^#$@!%*?&]{8,30}$/)) {
                passwordErr = 'Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.';
            }
        }
        if (!this.state.confirmPassword) {
            passwordMustSameError = 'Confirm Password can not be blank'
        }else{
            if(this.state.password !== this.state.confirmPassword){
                passwordMustSameError = 'Password and Confirm Password do not match'
              }
        }
    
        if (!this.state.email) {
            emailErr = 'This field is required.'
          }else{
            if (!this.state.email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
              emailErr = 'Email address must be valid email.';
          }
        
        } 
        
    
        this.setState({
            passwordErr, emailErr,passwordMustSameError
        })
        if (passwordErr || emailErr || passwordMustSameError) {
            return false
        }
        return true
    }

    submitFn = (e) => {
        e.preventDefault();
        const isValid = this.validate()
        if (isValid) {
            this.setState({
                loaderFlag: true,
              });
              this.resetPassword()
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    Showpassword = () => {
        this.setState({
            passShow: !this.state.passShow
        })
    }
    ConfirmShowpassword = () => {
        this.setState({
            confirmPassShow: !this.state.confirmPassShow
        })
    }

    clearFn = () => {
        this.setState({
            password: "",
            confirmPassword: ""
        });
    };

    render() {
        return (
            <AuthLayout>
                {/* Box Design Start here                          signUp_box_Wrapper */}
                <div className="box_wrapper  reset_box_Wrapper"> 
                    <h2>Reset Password</h2>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            <span style={{ color: 'red' }}>  {this.state.emailErr}</span>

                        </div>
                        <div>
                            <label>New Password</label>
                                <div className="relative mb_0">
                                <input
                                    type={this.state.passShow ? "text" : "password"}
                                    name="password"
                                    id="password"
                                    value={this.state.password}
                                    onChange={this.onInputChange}
                                />
                                <span className="eye_icon" onClick={this.Showpassword}> { this.state.passShow ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                            </div>
                                <span style={{ color: 'red' }} className='srv-validation-message'> {this.state.passwordErr}</span>
                                {this.state.passwordErr ? '' :
                                    <p className="suggession_text">Password must be at least 8 characters and include one lowercase letter, one uppercase letter, and one digit.</p>
                                }
                        </div>
                        <div>
                            <label>Confirm New Password</label>
                            <div className="relative mb_0">
                            <input
                                type={this.state.confirmPassShow ? "text" : "password"}
                                name="confirmPassword"
                                id="confirmPassword"
                                value={this.state.confirmPassword}
                                onChange={this.onInputChange}
                            />

                            {/* <span style={{ color: 'red' }}>{this.validator.message('Confirm Password', this.state.confirmPassword, `required|in:${this.state.password}`)}</span> */}
                            <span className="eye_icon" onClick={this.ConfirmShowpassword}> { this.state.confirmPassShow ? <ShowPasswordIcon />  : <ViewIcon /> } </span>
                            </div>
                            <span style={{ color: 'red' }} className='srv-validation-message'>{this.validator.message('confirm_password', this.state.confirmPassword, `required|in:${this.state.password}`, {messages: {in: 'Password and Confirm Password does not match.'}})}</span>
                        </div>
                        <div>
                            <p className=" text_center d_flex d_flex_justify_center d_flex_align_center" style={{fontSize:"14px"}}>Go back to <Link to="/ps-signin" className="link ml_5">Sign in</Link> </p>
                        </div>
                        <div>
                            <button
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                            >Clear</button>
                            <button
                                className="orangeBTN"
                                type="submit"
                                onClick={(e) => this.submitFn(e)}
                            >Submit</button>
                        </div>
                    </form>
                </div>
                {/* Box Design End's here */}

                 {/* Loader */}
                 {this.state.loaderFlag ? (
                    <Loader/>
                    ) : (
                    ""
                )}
            </AuthLayout>
        )
    }
}
export default Reset;